<template>
  <div>
    <h1>Change Who Recieves PEA Check Notifications</h1><br>
    <el-alert v-if="alertTitle !== ''"
      :title="alertTitle"
      :type="alertType"
      :description="callInfo"
      :closable="false"
      show-icon>
    </el-alert>
    <div class="el-cards">
      <el-card v-for="cn in checkNotifications" :key="cn.peaCheckTypeId" v-loading="cn.loading">
        <header>
          <h1>{{ cn.CheckDescription}}</h1>
        </header>
        <main>
          <span>Users receiving notifications:</span>
          <hr>
          <ul v-if="cn.users.length">
            <li v-for="(user, index) in cn.users" :key="user.userId">
              <el-button plain round :title="user.userEmail">{{user.userName}} <i class="el-icon-error" @click="removeUser(cn.peaCheckTypeId, user.userId, index)"></i></el-button>
            </li>
          </ul>
        </main>
        <footer>
          <el-input placeholder="Add additional user" v-model="cn.newUser"></el-input>
          <el-button type="primary" style="margin-left: 10px;" @click="addUserToCheckNotification(cn.peaCheckTypeId, cn.newUser)">Add</el-button>
        </footer>
      </el-card>
    </div>
  </div>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  data () {
    return {
      checkNotifications: [],
      alertType: '',
      alertTitle: '',
      callInfo: ''
    }
  },
  methods: {
    addUserToCheckNotification (peaCheckTypeId, username) {
      var duplicate = this.checkNotifications[peaCheckTypeId].users.some(user => {
        if (user.userName === username) {
          return true
        }
      })
      if (username && !duplicate) {
        var checkNotification = {
          peaCheckTypeId: peaCheckTypeId,
          isActive: true,
          userName: username
        }
        this.checkNotifications[peaCheckTypeId].loading = true
        this.$axios.post('/peaAddCheckNotification', checkNotification).then(response => {
          this.checkNotifications[peaCheckTypeId].users.push({
            userId: response.data.id,
            userName: response.data.userName,
            userEmail: response.data.userEmail
          })
          // reset input
          this.checkNotifications[peaCheckTypeId].newUser = ''
          this.checkNotifications[peaCheckTypeId].loading = false
        }).catch(response => {
          this.checkNotifications[peaCheckTypeId].loading = false
          helperMethods.showNotification(this, 'Error adding access', response.body, 'error', 30000)
        })
      }
    },
    removeUser (peaCheckTypeId, userId, index) {
      var checkNotification = {
        peaCheckTypeId: peaCheckTypeId,
        isActive: true,
        userId: userId
      }
      this.checkNotifications[peaCheckTypeId].loading = true
      this.$axios.post('/peaRemoveCheckNotification', checkNotification).then(response => {
        this.checkNotifications[peaCheckTypeId].users.splice(index, 1)
        this.checkNotifications[peaCheckTypeId].loading = false
      }).catch(response => {
        this.checkNotifications[peaCheckTypeId].loading = false
        helperMethods.showNotification(this, 'Error adding access', response.body, 'error', 30000)
      })
    },
    getCheckTypes () {
      this.$axios.get('/adminGetPEAChecks').then(response => {
        var data = response.data
        var dataReordered = {}
        data.forEach(cn => {
          dataReordered[cn.peaCheckTypeId] = {
            CheckDescription: cn.checkDescription,
            peaCheckTypeId: cn.peaCheckTypeId,
            users: []
          }
          dataReordered[cn.peaCheckTypeId].newUser = ''
          dataReordered[cn.peaCheckTypeId].loading = false
        })
        this.checkNotifications = dataReordered
        this.getNotifiers()
      }).catch(error => {
        helperMethods.showNotification(this, 'Error retrieveing Checks', error.body, 'error', 30000)
      })
    },
    getNotifiers () {
      this.$axios.get('/adminGetPEACheckNotifications').then(response => {
        var data = response.data
        var dataReordered = this.checkNotifications
        data.forEach(cn => {
          dataReordered[cn.peaCheckTypeId].users.push({
            userId: cn.userId,
            userName: cn.userName,
            userEmail: cn.userEmail
          })
          dataReordered[cn.peaCheckTypeId].newUser = ''
          dataReordered[cn.peaCheckTypeId].loading = false
        })
        this.checkNotifications = dataReordered
      }).catch(error => {
        helperMethods.showNotification(this, 'Error adding access', error.body, 'error', 30000)
      })
    }
  },
  mounted () {
    this.getCheckTypes()
  }
}
</script>

<style lang="css" scoped>
.el-cards {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

.el-card__body header {
  border-bottom: 1px solid #eee;
  padding: 10px 20px 0;
  background: aliceblue;
  margin-bottom: 2px;
}

.el-card h1 {
  font-size: 1.4rem;
  font-weight: bold;
  color: #00a9c3;
  padding: 1px 0;
}

.el-card main {
  padding: 10px 20px;
}

hr {
  margin-top: 10px !important;
  border-width: 1px !important;
  border-color: #eee !important;
}

ul {
  padding: 0;
  list-style: none;
}

li {
  margin: 0 0 10px;
}

.el-button i {
  margin-right: -5px;
  margin-left: 5px;
}

footer {
  padding: 20px;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
}
</style>

<style>
  .el-cards .el-card {
    box-shadow: none;
    margin: 0 10px 20px;
    position: relative;
  }
  .el-cards .el-card__body {
    padding: 0;
  }

  button:focus, button:active, button:visited {
    outline: none !important;
  }
</style>
